module.exports = __webpack_public_path__ + "img/feature6.0d7c1da.png";